import { UnitType } from '@exodus/currency'

const name = 'aptos'
const displayName = 'Aptos'
const ticker = 'APT'
const displayTicker = 'APT'
const displayNetworkTicker = displayTicker
const displayNetworkName = displayName
const baseAssetName = name
const primaryColor = '#2ED8A7'
const gradientColors = ['#2ED8A7', '#7AFFD9']
const gradientCoords = { x1: '0%', y1: '0%', x2: '20%', y2: '20%' }
const chainBadgeColors = gradientColors

const units = {
  base: 0,
  APT: 8,
}

const currency = UnitType.create(units)

const assetType = 'OTHER'
const derivationAlgorithm = 'SLIP10'
const curve = 'ed25519'

const blockExplorer = {
  addressUrl: (accountId) =>
    `https://explorer.aptoslabs.com/account/${encodeURIComponent(accountId)}`,
  txUrl: (txId) => `https://explorer.aptoslabs.com/txn/${encodeURIComponent(txId)}`,
}
const info = {
  description:
    'Aptos is a Layer 1 blockchain for everyone. It uses the Move programming language and launched its mainnet on 2022-10-17 to redefine the web3 user experience. The Aptos blockchain is dedicated to creating better user experiences through increased speed, security, scalability, reliability and usability with low transaction costs.',
  reddit: 'https://www.reddit.com/r/Aptos',
  twitter: 'https://twitter.com/Aptos_Network',
  website: 'https://aptosfoundation.org/',
  telegram: 'https://t.me/AptosLabs',
}

export const asset = {
  assetType,
  baseAssetName,
  blockExplorer,
  chainBadgeColors,
  currency,
  curve,
  derivationAlgorithm,
  displayName,
  displayNetworkName,
  displayNetworkTicker,
  displayTicker,
  gradientColors,
  gradientCoords,
  info,
  name,
  primaryColor,
  properName: displayName, // deprecated
  properTicker: displayTicker, // deprecated
  ticker,
  toString: () => name,
  units,
}

export default [asset]
